import React from 'react';
import { inject, observer} from 'mobx-react';
import {Button, Spin, Icon} from 'antd'
import isEmpty from 'lodash/isEmpty'
import {WeaDialog, WeaSearchGroup, WeaTools, WeaNewScroll,WeaFormItem} from 'ecCom';
import {WeaSwitch} from 'comsMobx'
import UploadAvatar from '../../../../pc4public/hrm/uploadAvatar'
const getKey = WeaTools.getKey;
import * as mobx from 'mobx';
const toJS = mobx.toJS;
import {i18n} from '../../public/i18n';

let __this;
@inject('hrmAdd')

@observer
class Simple extends React.Component {
    constructor(props) {
        super(props);
        __this = this;
        const funcs = ['save','doSaveAndNew', 'more', 'openFullmode'];
        funcs.forEach(f=> this[f] = this[f].bind(this));
    }
    componentWillReceiveProps(nextProps) {
        const { hrmAdd } = this.props;
        const { conditionInfo } = hrmAdd;
        if ('visible' in nextProps && this.props.visible !== nextProps.visible) {
            if (nextProps.visible) {
                if (isEmpty(conditionInfo)) this.init();
                hrmAdd.updateScroll = true;
                hrmAdd.canSave = true;
            } else {
                hrmAdd.conditionInfo = [];
            }
        }
    }
    componentDidUpdate() {
        const { hrmAdd } = this.props;
        const { updateScroll } = hrmAdd;
        if (updateScroll) {
            if (this.refs.scrollBar) {
                setTimeout(()=> {
                    this.refs.scrollBar.scrollerToTop();
                }, 0);
            }
            hrmAdd.updateScroll = false;
        }
    }
    componentDidMount(){
        this.init();
    }

    init() {
        const {hrmAdd} = this.props;
        hrmAdd.getHrmResourceAddForm({'type':'simple'});
    }

    save(){
        const {hrmAdd} = this.props;
        hrmAdd.save();
    }

    doSaveAndNew(){
        const {hrmAdd} = this.props;
        hrmAdd.doSaveAndNew();
    }

    more(){

    }

    openFullmode(){
        const {hrmAdd} = this.props;
        hrmAdd.openFullmode();
    }

    getSearchs(){
        const {hrmAdd} = this.props;
        const {formSimple,conditionInfo} = hrmAdd;
        const {isFormInit} = formSimple;
        const formParams = formSimple.getFormParams();
        let group = [];
        window.e9HideFormFieldKeys = [];
        isFormInit && conditionInfo && conditionInfo.forEach(c =>{
            let items = [];
            c.items.forEach( field => {
                let hide = false;
                if ((!formParams.accounttype || formParams.accounttype == '0') && field.domkey[0] == 'belongto') hide = true;
                if (formParams.accounttype == '1' && (field.domkey[0] == 'loginid' || field.domkey[0] == 'password' || field.domkey[0] == 'password1')) hide = true;
                let dom;
                if (field.conditionType == 'RESOURCEIMG') {
                    const key = getKey(field);
                    const bindObj = formSimple.$(key);
                    dom = <UploadAvatar {...bindObj.bind()}/>
                }else {
                    dom =  <WeaSwitch fieldConfig={mobx.toJS(field)} form={formSimple}/>;
                }
                if(c.hide || !isEmpty(field.otherParams) && field.otherParams.hide){
                    window.e9HideFormFieldKeys.push(field.domkey[0]);
                }else{
                    items.push({
                        com:<WeaFormItem
                            label={`${field.label}`}
                            labelCol={{span: `${field.labelcol}`}}
                            wrapperCol={{span: `${field.fieldcol}`}}>
                                {dom}
                            </WeaFormItem>,
                        colSpan: 1,
                        hide: hide
                    });
                }
            });
            group.push(<WeaSearchGroup className='hrm-center' hide={c.hide}
                       needTigger={true} title={c.title} showGroup={c.defaultshow} items={items} col={1}/>)
        });
        return group;
    }

    render() {
        const {hrmAdd} = this.props;
        const {title,loading} = hrmAdd;
        let dialogHeight = window.innerHeight-250;
        if(dialogHeight>660)dialogHeight = 660;
        return <WeaDialog
                {...this.props}
                closable
                className="hrm-addsimple"
                style={{width: 800, height: dialogHeight}}
                title = {title()}
                icon="icon-coms-hrm"
                iconBgcolor='#217346'
                buttons = {this.getBtns()}
                moreBtn={{datas:[]}}
            >
                <Spin spinning={loading}>
                    <WeaNewScroll height={dialogHeight} ref="scrollBar">
                        {this.getSearchs()}
                    </WeaNewScroll>
                </Spin>
            </WeaDialog>
    }

    getBtns() {
        const {hrmAdd} = this.props;
        const {canSave} = hrmAdd;
        return [
            (<div className="ext-link" style={{float: 'left',cursor:'pointer'}} onClick={this.openFullmode}>{i18n.button.fullModle()}<Icon type="double-right" />
            </div>),
            (<Button type="primary" disabled={!canSave} onClick={this.save}>{i18n.button.save()}</Button>),
            (<Button type="primary" disabled={!canSave} onClick={this.doSaveAndNew}>{i18n.button.saveAndCreate()}</Button>),
        ]
        return btns;
    }
}

export default Simple


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/add/simple.js